module.exports = __webpack_public_path__ + "img/img1_7.d7962ad2.jpeg";